module.exports = __webpack_public_path__ + "img/step7-c.38038741.png";